import React from 'react'

const MajorPaint = props => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.25 10.54a2.68 2.68 0 012.27 1.38c.74 1.35.41 3.44-.87 5.46A9.9 9.9 0 0112.4 22h-.65a9.9 9.9 0 01-8.82-6.35c-1.55-3.81-.96-8.46 1.4-11.07 2.48-2.77 6-3.12 8-1.85a2.92 2.92 0 011.11 3.8c-.57 1.39-.87 2.43-.57 2.87.3.44 1.17.75 2.6.92.81-2.66 2.39-7.1 4.16-7.93a1.57 1.57 0 011.37 0c.418.215.721.602.83 1.06.42 1.58-1.17 4.73-2.58 7.09zm1.13-6.7c-.06-.07-.08-.07-.15-.07-.99.47-2.33 3.74-3.26 6.73-.15.48-.29.96-.42 1.41h.06c.25-.342.5-.753.75-1.164l.15-.246c1.62-2.6 3.16-5.66 2.87-6.66zm-5.15 10.48l.71-1.06h.09l-.26 1.19-.54.48v-.61zm-3.37 6.16a8.33 8.33 0 007.53-3.91h-.01c.95-1.48 1.28-3.1.88-3.91a1.3 1.3 0 00-1.27-.61h-.6c-.31.48-.57.87-.75 1.12l-.4 1.91a.83.83 0 01-.24.4l-2 1.74a.73.73 0 01-.8.12.75.75 0 01-.45-.68v-2.54a.74.74 0 01.13-.41l1.11-1.68v-.19c-1.83-.25-2.89-.76-3.43-1.56-.78-1.18-.24-2.7.44-4.28a2 2 0 00.19-.81A1.4 1.4 0 0011.48 4a3.42 3.42 0 00-1.82-.43 5.82 5.82 0 00-4.27 2.05c-1.99 2.2-2.46 6.19-1.12 9.49a8.38 8.38 0 007.59 5.37zM8 10a2.25 2.25 0 10-.1-4.499A2.25 2.25 0 008 10zm.75-2.25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM9.38 13a2 2 0 10-2 2 2 2 0 001.95-2h.05zm-2.5 0a.5.5 0 00.5.5l-.05-.04a.5.5 0 00.55-.46.5.5 0 00-1 0zm3.87 1.85a2 2 0 102 2 2 2 0 00-2.05-2.04l.05.04zm-.5 2a.51.51 0 00.5.5l-.05-.04a.5.5 0 00.55-.46.5.5 0 00-1 0z"
      fill={props.fill || '#fff'}
    />
  </svg>
  )

export default MajorPaint
